import { memo } from "react";
import { Link } from "react-router";

import type { DiscountListForDiscountQuery } from "@/lib/gql/__generated__/graphql";

import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithBackGround,
} from "@/components/features/_layouts";

import { DiscountList as _DiscountList } from "./components";
import { ListTableHeader } from "../../../edit/_shared/ui/components/system/list/list-table-header";
import { useInitialized } from "../model/use-case";

const NOTION_URL = "https://chillnn.notion.site/1bafffe15c57807e9c0fc17ba027be5a";

type Props = {
	hotelID: string;
	data: DiscountListForDiscountQuery;
};

export const DiscountListPresenter = memo(({ hotelID, data }: Props) => {
	const {
		queryData,

		onDeleteDiscount,
		// ordinary
		onTransitionToAddOrdinaryDiscount,
		onTransitionToEditOrdinaryDiscount,
		onTransitionToDuplicateOrdinaryDiscount,
		// longTermStay
		onTransitionToAddLongTermStayDiscount,
		onTransitionToEditLongTermStayDiscount,
		onTransitionToDuplicateLongTermStayDiscount,
		// multi
		onTransitionToAddMultiDiscount,
		onTransitionToEditMultiDiscount,
		onTransitionToDuplicateMultiDiscount,
	} = useInitialized({ hotelID, data });

	return (
		<FeatureIslandContainer>
			<FeatureIslandHeader title="ディスカウント一覧" />

			<FeatureIslandMainWithBackGround>
				<div className="space-y-12">
					<div className="flex flex-wrap items-center justify-between gap-y-2">
						<p className="flex gap-x-2">
							ディスカウントに関する詳細な説明は
							<Link
								to={NOTION_URL}
								className="text-link-400 underline-offset-4 hover:underline"
								target="_blank"
								viewTransition
							>
								こちら
							</Link>
							をご覧ください。
						</p>

						<ListTableHeader
							createNewItemList={[
								{
									title: "通常ディスカウント",
									handleClick: onTransitionToAddOrdinaryDiscount,
								},
								{
									title: "連泊ディスカウント",
									handleClick: onTransitionToAddLongTermStayDiscount,
								},
								{
									title: "複合ディスカウント",
									handleClick: onTransitionToAddMultiDiscount,
								},
							]}
						/>
					</div>

					<_DiscountList
						onDeleteDiscount={onDeleteDiscount}
						// ordinary
						ordinary={queryData.ordinary}
						onTransitionToEditOrdinaryDiscount={onTransitionToEditOrdinaryDiscount}
						onTransitionToDuplicateOrdinaryDiscount={onTransitionToDuplicateOrdinaryDiscount}
						// longTermStay
						longTermStay={queryData.longTerm}
						onTransitionToEditLongTermStayDiscount={onTransitionToEditLongTermStayDiscount}
						onTransitionToDuplicateLongTermStayDiscount={onTransitionToDuplicateLongTermStayDiscount}
						// multi
						multi={queryData.multi}
						onTransitionToEditMultiDiscount={onTransitionToEditMultiDiscount}
						onTransitionToDuplicateMultiDiscount={onTransitionToDuplicateMultiDiscount}
					/>
				</div>
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
});

DiscountListPresenter.displayName = "DiscountListPresenter";
